module.exports = __webpack_public_path__ + "static/img/Jackson-Hastings.3792bfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jackson-Hastings.jpg
// module id = tQEE
// module chunks = 0